function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 425.34 152.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.03,
    y: -100.48,
    width: 86,
    height: 358.62,
    rx: 43,
    ry: 43,
    transform: "translate(167.19 324.86) rotate(-90)",
    style: {
      fill: "#f2ab87",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204,51.21v29.51h-8.18l-11.21-13.41v13.41h-9.7v-29.51h8.18l11.21,13.41v-13.41h9.7Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.34,73.22v7.5h-24.54v-29.51h23.99v7.5h-14.21v3.46h12.48v7.17h-12.48v3.88h14.76Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.38,80.28c-1.87-.75-3.41-1.83-4.62-3.27l5.35-6.32c.79.98,1.56,1.71,2.32,2.19.76.48,1.55.72,2.36.72,1.04,0,1.83-.31,2.38-.93s.82-1.53.82-2.74v-11.21h-10.03v-7.5h19.86v18.13c0,4.02-1.03,7.03-3.1,9.04-2.07,2.01-5.09,3.01-9.09,3.01-2.3,0-4.39-.37-6.26-1.12Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.24,80.58c-2.32-.55-4.22-1.29-5.71-2.21l3.21-7.25c1.4.82,2.98,1.47,4.72,1.96,1.74.49,3.42.74,5.02.74,1.38,0,2.36-.13,2.95-.4.59-.27.88-.67.88-1.2,0-.62-.39-1.08-1.16-1.39-.77-.31-2.04-.65-3.82-1.01-2.28-.48-4.17-.99-5.69-1.54-1.52-.55-2.84-1.45-3.96-2.7-1.12-1.25-1.69-2.94-1.69-5.08,0-1.85.52-3.54,1.56-5.06,1.04-1.52,2.59-2.71,4.66-3.58,2.07-.87,4.58-1.31,7.53-1.31,2.02,0,4.01.22,5.97.65,1.95.44,3.67,1.08,5.16,1.92l-2.99,7.21c-2.9-1.46-5.64-2.19-8.22-2.19s-3.84.62-3.84,1.85c0,.59.38,1.03,1.14,1.33s2.01.61,3.75.95c2.25.42,4.15.91,5.69,1.46,1.54.55,2.89,1.44,4.03,2.68,1.14,1.24,1.71,2.92,1.71,5.06,0,1.86-.52,3.54-1.56,5.04-1.04,1.5-2.59,2.7-4.66,3.58-2.07.88-4.57,1.33-7.53,1.33-2.45,0-4.83-.27-7.15-.82Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.43,80.73l-.08-13.45-6.41,10.79h-4.38l-6.41-10.33v12.99h-9.06v-29.51h8.18l9.61,15.73,9.36-15.73h8.18l.08,29.51h-9.06Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.84,73.22v7.5h-24.54v-29.51h23.99v7.5h-14.21v3.46h12.48v7.17h-12.48v3.88h14.76Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.2,51.21h11.38l-1.9,18.21h-7.59l-1.9-18.21Zm1.69,28.46c-1.04-.98-1.56-2.18-1.56-3.58s.52-2.62,1.56-3.56c1.04-.94,2.38-1.41,4.01-1.41s2.96.47,4,1.41c1.04.94,1.56,2.13,1.56,3.56s-.52,2.6-1.56,3.58-2.38,1.48-4,1.48-2.97-.49-4.01-1.48Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.73,90.67c3.92,0,6.18,1.93,6.18,5.35,0,3.6-2.26,5.68-6.18,5.68h-2.78v4.32h-3.9v-15.35h6.69Zm-2.78,7.96h2.59c1.71,0,2.7-.85,2.7-2.48s-.99-2.41-2.7-2.41h-2.59v4.89Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.92,101.7h-3.07v4.32h-3.9v-15.35h6.86c4.06,0,6.38,1.93,6.38,5.35,0,2.35-.99,4.04-2.78,4.93l3.22,5.07h-4.43l-2.28-4.32Zm-4.93-15.9h2.96l1.34,2.02,1.34-2.02h2.96l-2.65,3.6h-3.29l-2.65-3.6Zm4.82,12.83c1.69,0,2.68-.85,2.68-2.48s-.99-2.41-2.68-2.41h-2.96v4.89h2.96Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.82,106.02v-15.35h3.9v15.35h-3.9Zm2.94-16.69h-2.89l2.32-3.68,3.42,1.21-2.85,2.48Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.74,101.04c0,3.27-2.04,5.15-5.31,5.15-2.17,0-3.92-.9-5.28-2.46l1.8-2.61c1.1,1.14,2.32,1.71,3.22,1.71,1.03,0,1.64-.64,1.64-1.89v-7.15h-5.26v-3.16h9.19v10.39Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.45,93.74v3.05h7.32v3.07h-7.32v3.09h8.35v3.07h-12.26v-15.35h12.02v3.07h-8.11Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.74,106.02l-.02-9.98-3.68,8.44h-2.54l-3.68-8.44v9.98h-3.49v-15.37h4.28l4.17,9.14,4.17-9.14h4.25v15.37h-3.44Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.64,93.13l-2.26,2.67c-1.01-1.23-2.5-2-3.86-2-2.43,0-4.28,1.93-4.28,4.45s1.84,4.52,4.28,4.52c1.29,0,2.78-.7,3.86-1.8l2.28,2.41c-1.64,1.69-4.08,2.81-6.34,2.81-4.63,0-8.07-3.4-8.07-7.89s3.53-7.76,8.2-7.76c2.28,0,4.65,1.01,6.18,2.59Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.44,106.02v-15.35h3.9v15.35h-3.9Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.1,90.67c4.82,0,8.16,3.11,8.16,7.67s-3.38,7.67-8.31,7.67h-6.45v-15.35h6.6Zm-2.7,12.24h2.78c2.39,0,4.1-1.84,4.1-4.54s-1.8-4.58-4.28-4.58h-2.61v9.12Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.62,98.33c0,4.47-3.55,7.87-8.31,7.87s-8.29-3.38-8.29-7.87,3.55-7.78,8.29-7.78,8.31,3.33,8.31,7.78Zm-12.61.02c0,2.59,2,4.58,4.34,4.58s4.25-2,4.25-4.58-1.89-4.54-4.25-4.54-4.34,1.95-4.34,4.54Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.28,93.81v12.21h-3.9v-12.21h-4.58v-3.16h13.11v3.16h-4.63Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.41,103.19l-1.12,2.83h-4.01l6.62-15.35h4.01l6.47,15.35h-4.17l-1.1-2.83h-6.71Zm3.38-8.64l-2.24,5.68h4.43l-2.19-5.68Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.76,93.13l-2.26,2.67c-1.01-1.23-2.5-2-3.86-2-2.43,0-4.28,1.93-4.28,4.45s1.84,4.52,4.28,4.52c1.29,0,2.78-.7,3.86-1.8l2.28,2.41c-1.64,1.69-4.08,2.81-6.34,2.81-4.63,0-8.07-3.4-8.07-7.89s3.53-7.76,8.2-7.76c2.28,0,4.65,1.01,6.18,2.59Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.56,106.02v-15.35h3.9v15.35h-3.9Zm2.94-16.69h-2.89l2.32-3.68,3.42,1.21-2.85,2.48Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.97,127.1L100.56,8.62c-3.07-5.32-8.79-8.62-14.93-8.62s-11.86,3.3-14.93,8.62L2.3,127.1c-3.07,5.32-3.07,11.92,0,17.24,3.07,5.32,8.79,8.62,14.93,8.62h136.81c6.14,0,11.86-3.3,14.93-8.62,3.07-5.32,3.07-11.92,0-17.23Z",
    style: {
      fill: "#cc6d1e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.63,10.79c2.17,0,4.34,1.07,5.58,3.22l68.41,118.48c2.48,4.3-.62,9.67-5.58,9.67H17.23c-4.96,0-8.06-5.37-5.58-9.67L80.05,14.01c1.24-2.15,3.41-3.22,5.58-3.22h0Zm0-5.39c-4.28,0-8.11,2.21-10.25,5.92L6.97,129.8c-2.14,3.71-2.14,8.13,0,11.84,2.14,3.71,5.97,5.92,10.25,5.92h136.81c4.28,0,8.11-2.21,10.25-5.92,2.14-3.71,2.14-8.13,0-11.84L95.89,11.31c-2.14-3.71-5.97-5.92-10.25-5.92h0Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.64,64.75c.73-1.7,1.13-3.53,1.13-5.44,0-9.07-9.02-17.39-20.14-17.39s-20.14,8.32-20.14,17.39c0,1.91.4,3.73,1.13,5.44.76,1.77.73,3.79,0,5.58-.11.28-.17.57-.17.87,0,1.92,2.43,3.48,5.42,3.48.83,0,1.62-.12,2.32-.34.61.5.82.66,1.43,1.15l-.56,3.74c-.15,1.68,1.17,3.13,2.86,3.13h15.39c1.69,0,3.01-1.45,2.86-3.13l-.55-3.65c.65-.52.86-.69,1.5-1.21.68.2,1.44.31,2.25.31,2.99,0,5.42-1.56,5.42-3.48,0-.3-.06-.59-.17-.87-.72-1.79-.75-3.81,0-5.58Zm-22.6,1.21c-2.13,2.27-4.96,2.12-6.71,1.36-2.21-.96-2.64-4.34-1.21-5.41,3.72-2.79,8.26-.79,8.71.62.45,1.42-.79,3.43-.79,3.43Zm13.89,1.36c-1.74.76-4.58.9-6.71-1.36,0,0-1.23-2.01-.79-3.43.45-1.42,4.99-3.41,8.71-.62,1.43,1.07,1,4.45-1.21,5.41Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.31,100.4c-.83-.18-1.65-.07-2.35.24-2.13.95-4.6.74-6.68-.32l-12.13-6.15,12.19-6.19c2.1-1.07,4.57-1.16,6.74-.22.41.17.85.28,1.33.31,2.03.11,3.75-1.34,3.85-3.23.08-1.42-.78-2.68-2.07-3.28-.71-.33-1.13-1.06-1.19-1.83-.06-.77-.39-1.51-.92-2.11-1.26-1.41-3.51-1.46-5.02-.1-.63.57-1.03,1.29-1.19,2.04-.49,2.28-2.12,4.15-4.2,5.21l-14.03,7.12-14.03-7.12c-2.08-1.06-3.71-2.93-4.2-5.21-.16-.75-.56-1.47-1.19-2.04-1.51-1.35-3.76-1.31-5.02.1-.54.6-.86,1.35-.93,2.11-.06.78-.48,1.51-1.19,1.83-1.29.59-2.14,1.86-2.07,3.28.1,1.89,1.83,3.34,3.85,3.23.47-.03.92-.13,1.33-.31,2.17-.93,4.64-.84,6.74.22l12.19,6.19-12.13,6.15c-2.08,1.06-4.55,1.27-6.68.32-.7-.31-1.52-.41-2.35-.24-1.98.42-3.28,2.26-2.89,4.12.13.62.45,1.15.9,1.56.83.78,1.17,1.92,1.1,3.05-.07,1.2.37,2.38,1.37,3.02,1.59,1.03,3.77.5,4.88-1.2.26-.4.43-.82.53-1.25.53-2.3,2.06-4.24,4.16-5.31l15.63-7.93,15.63,7.93c2.1,1.07,3.63,3.01,4.16,5.31.1.43.28.85.53,1.25,1.11,1.7,3.29,2.24,4.88,1.2.99-.65,1.44-1.82,1.37-3.02-.07-1.14.27-2.27,1.1-3.05.44-.42.77-.95.9-1.56.39-1.85-.9-3.7-2.89-4.12Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.44,121.67h5.58c1.26,0,2.38.23,3.34.69.96.46,1.71,1.11,2.25,1.97.53.85.8,1.86.8,3.01s-.27,2.16-.8,3.01c-.53.85-1.28,1.51-2.25,1.97-.97.46-2.08.69-3.34.69h-5.58v-11.33Zm5.42,8.35c.82,0,1.48-.23,1.97-.7.49-.47.74-1.13.74-1.98s-.25-1.51-.74-1.98c-.49-.47-1.15-.7-1.97-.7h-1.6v5.37h1.6Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.37,132.49c-.97-.51-1.73-1.21-2.28-2.11-.55-.9-.83-1.92-.83-3.05s.27-2.15.83-3.05c.55-.9,1.31-1.6,2.28-2.11.97-.51,2.07-.76,3.29-.76s2.31.25,3.29.76c.97.51,1.73,1.21,2.28,2.11.55.9.83,1.92.83,3.05s-.27,2.15-.83,3.05c-.55.9-1.31,1.6-2.28,2.11-.97.51-2.07.76-3.29.76s-2.31-.25-3.29-.76Zm4.57-2.68c.38-.23.69-.56.91-.99.23-.43.34-.92.34-1.5s-.11-1.07-.34-1.5c-.23-.43-.53-.75-.91-.99-.38-.23-.81-.35-1.29-.35s-.9.12-1.29.35c-.38.23-.69.56-.91.99-.23.43-.34.92-.34,1.5s.11,1.07.34,1.5c.23.43.53.75.91.99.38.23.81.35,1.29.35s.9-.12,1.29-.35Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.65,124.63h-3.32v-2.96h10.46v2.96h-3.32v8.37h-3.82v-8.37Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.84,131.02h-4.3l-.76,1.97h-3.88l4.95-11.33h3.75l4.95,11.33h-3.95l-.76-1.97Zm-1.05-2.75l-1.1-2.85-1.1,2.85h2.2Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.54,132.5c-.96-.5-1.71-1.2-2.26-2.1-.54-.9-.82-1.92-.82-3.07s.27-2.17.82-3.07c.54-.9,1.3-1.6,2.26-2.1.96-.5,2.04-.75,3.24-.75,1.1,0,2.08.19,2.95.58.86.39,1.57.95,2.14,1.68l-2.41,2.15c-.7-.88-1.53-1.33-2.48-1.33-.8,0-1.44.26-1.93.77-.49.51-.73,1.2-.73,2.06s.24,1.55.73,2.06c.49.51,1.13.77,1.93.77.95,0,1.78-.44,2.48-1.33l2.41,2.15c-.56.73-1.27,1.29-2.14,1.68-.86.39-1.85.58-2.95.58-1.2,0-2.28-.25-3.24-.75Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.29,130.11v2.88h-9.42v-11.33h9.21v2.88h-5.45v1.33h4.79v2.75h-4.79v1.49h5.66Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotace);
export default __webpack_public_path__ + "static/media/dotace.335898f8aa69f68abbe5a663a7d32cc5.svg";
export { ForwardRef as ReactComponent };